import { Component, ComponentRef, EventEmitter, OnInit, Output } from "@angular/core";
import { GeneralComponent } from "../general.component";
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormularioService } from "src/app/services/formulario.service";
import { GeneralService } from "src/app/services/general.service";
import { NotificationService } from "src/app/services/notification.service";
import { MatDialog } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import { DropDownListDTO } from "src/app/entity/dto/dropdownlist.component";
import { take } from "rxjs/operators";
import { Rs005CardIIComponent } from "src/app/views/form-rs005/partialViews/rs005-card-II.component";
@Component({
    selector: 'app-rs005-source-item',
    templateUrl: './rs005-source-item.component.html',
})
export class Rs005SourceItemComponent extends GeneralComponent implements OnInit {

    public formulario?: FormGroup;
    public parentRef: Rs005CardIIComponent;
    public unique_key: number;
    public btnExcluir = false
    @Output() componentsReferences = Array<ComponentRef<Rs005SourceItemComponent>>()
    @Output() mkCalc = new EventEmitter<Number>();
    @Output() calcDates = new EventEmitter();
    public listRessecagem?: DropDownListDTO[];

    constructor(protected formularioService: FormularioService,
        protected formBuilder: FormBuilder,
        protected notificationService: NotificationService,
        protected generalService: GeneralService,
        public dialog: MatDialog,
        private add: Store<any>,) {
        super('', false);
        this.formulario = this.formBuilder.group({
            id: [null, []],
            source: [null, []],
            lote: [null, []],
          
        });
    }

    async ngOnInit() {
    }
    hasErrorFormControl(campoFormulario: AbstractControl) {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }
    makeCalculations() {
        this.mkCalc.emit();
    }


    public remove(lastItem = false) {
        this.parentRef.removeSecagemItemComponent(this.unique_key, lastItem);
    }

}